"use client"

import MobileNav from "../../components/MobileNav"
import "./AboutUs.css"

export default function AboutUs() {
  return (
    <div className="about-page">
      <header className="light-header">
        <div className="container">
          <div className="logo">
            <a href="/" style={{ textDecoration: "none", fontWeight: "800", fontSize: "1.8rem", color: "#2c3e50" }}>
              Uniquely<span style={{ color: "#c0392b" }}>Sharp</span>
            </a>
          </div>
          <nav className="desktop-nav">
            <a href="/">Home</a>
            <a href="/events">Events</a>
            <a href="/products">Products</a>
            <a className="active" href="/about">
              About Us
            </a>
            <a href="/contact">Contact</a>
          </nav>
          <MobileNav />
        </div>
      </header>

      <div className="hero-section" style={{ backgroundImage: `url('assets_task_01jrkhprmsff3v3vdw79kcs964_img_0.webp')` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>About Us</h1>
          <p>Inspired by quality</p>
        </div>
      </div>

      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              <img src="assets_task_01jrkghjwnf8fap5dehnt24kmm_img_1.webp" alt="Uniquely Sharp workshop" />
            </div>
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
              At Uniquely Sharp, we’re all about blades—with style, precision, and quality that cut above the rest. What started at local flea markets and vendor shows has grown into a full-blown passion for delivering top-tier swords, katanas, and knives to fans across the country.
              </p>
              <p>
              Whether you're a die-hard anime collector, a martial arts enthusiast, or just someone who appreciates the craftsmanship of a well-made blade, we've got you covered. Our inventory is always stocked, and our products are handpicked for quality, durability, and design.
              </p>
              <p>
              We believe everyone deserves a blade that feels as epic as it looks. That’s why we’re on a mission to make high-quality, sharp, and stylish gear accessible to anyone who wants to wield it.
              </p>
              <p>
              By purchasing any item, the buyer acknowledges and agrees that the seller shall not be held responsible for any unlawful or unauthorized use of the purchased item. The buyer assumes all responsibility for the lawful use, handling, and distribution of the purchased item, and agrees not to hold the seller liable for any unlawful activities conducted with the purchased product. All sales are based in the state of lowa.
              </p>
            </div>
          </div>

          <div className="about-highlights">
            <div className="highlight-box">
              <div className="highlight-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3>Quality Materials</h3>
              <p>We use only premium materials sourced from trusted suppliers around the world.</p>
            </div>

            <div className="highlight-box">
              <div className="highlight-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                </svg>
              </div>
              <h3>Availability</h3>
              <p>We offer full availability in our products.</p>
            </div>

            <div className="highlight-box">
              <div className="highlight-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </div>
              <h3>Customer Satisfaction</h3>
              <p>We stand behind every product we make with a lifetime guarantee against defects.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer-section">
        <div className="footer-content">
          <div className="footer-column">
            <h3>
              Uniquely<span>Sharp</span>
            </h3>
            <p>Premium quality knives and cutting tools for professionals and enthusiasts.</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/g/15nBKAPV6a/?mibextid=wwXIfr" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/uniquely_sharp" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/events">Events</a>
              </li>
              <li>
                <a href="/products">Products</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <p>
            Bettendorf, Iowa
            </p>
            <p>
            UniquelySharpContact@gmail.com
              <br />
              (+1) 563-508-2716
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2025 <strong>Uniquely Sharp</strong>. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}
